import { VimeoFrame } from "src/utils/fw"
import { auditoriumCloseDate } from "../utils"

const background = () => {
	const now = new Date()
	if (now < new Date("2023-10-24 08:00:00+0200")) return "https://assets.swoogo.com/uploads/full/3076275-6531b29976241.png" // Day One
	else if (now < auditoriumCloseDate) return "https://assets.swoogo.com/uploads/full/3076276-6531b29977685.png" // Day Two
	else return "https://assets.swoogo.com/uploads/full/3076274-6531b29975aa0.png" // Day Three
}

const links = [
    {
        top: `13%`,
        left: `17.6%`,
        href: "/875167577",
        width: `65.2%`,
        height: `7%`,
        label: "Beau Lotto: Thriving in uncertainty"
    },
    {
        top: `21%`,
        left: `17.6%`,
        href: "/875171158",
        width: `65.2%`,
        height: `7%`,
        label: "Konstantinos Karagiannis: Quantum Computing: The promise and the threat"
    },
    ...(new Date() >= new Date("2023-10-24 08:00:00+0200") ? [
        {
            top: `38%`,
            left: `17.6%`,
            href: "/875167541",
            width: `65.2%`,
            height: `7%`,
            label: "Peter Hinssen: The day after tomorrow, how to survive in times of radical innovation"
        },
        {
            top: `46%`,
            left: `17.6%`,
            href: "/875167506",
            width: `65.2%`,
            height: `7%`,
            label: "Nina Schick: The future of information integrity"
        }
    ] : []),
    ...(new Date() >= auditoriumCloseDate ? [
        {
            top: `64%`,
            left: `17.6%`,
            href: "/875167385",
            width: `65.2%`,
            height: `7%`,
            label: "Tali Sharot: Changing behaviour: Why facts alone don't work"
        },
        {
            top: `72%`,
            left: `17.6%`,
            href: "/875167443",
            width: `65.2%`,
            height: `7%`,
            label: "Helle Thorning-Schmidt: Inclusive LeadershipNina Schick: The future of information integrity"
        }
    ] : [])
].map(it => {
    const params = "?badge=0&autopause=0&quality_selector=1&progress_bar=1&player_id=0&app_id=58479"
    return {
        ...it,
        href: undefined,
        modal: <VimeoFrame wrapperStyle={{ backgroundColor: "rgb(59, 80, 206)" }} vidId={it.href.replace(/^\//, "") + params} />
    }
})

export default {
    background: background(), // In case of problems, put BG URL here
    name: "keynotes",
    links: [
        ...links,
		{
			top: `92.6%`,
			left: `42.6%`,
			href: "/atrium",
			width: `14.7%`,
			height: `6%`,
			label: "Back to Atrium"
		}
    ]
}